export class GenericResultSet<R> {
    Total: number;
    Results: R[];
}